import React from 'react';

export default class ClickOutside extends React.Component {
  // static propTypes = {
  //   onClickOutside: PropTypes.func.isRequired,
  // };

  componentDidMount() {
    document.addEventListener('click', this.handle, true);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handle, true);
  }

  handle = (e) => {
    const { onClickOutside } = this.props;
    const el = this.container;
    if (!el.contains(e.target)) onClickOutside(e);
  };

  render() {
    const { children, onClickOutside, ...props } = this.props;
    return <span {...props} ref={ref => this.container = ref}>{children}</span>;
  }
}
